<template>
  <div>
    <el-autocomplete v-if="searchBy === 'email'"
                     placeholder="Email"
                     v-model="email"
                     :fetch-suggestions="searchByEmail"
                     :debounce="500"
                     :trigger-on-focus="false"
                     value-key="email"
                     @select="getOrders">
      <i class="el-input__icon" :class="[loading ? 'el-icon-loading' : 'el-icon-search']"
         slot="suffix">
      </i>
    </el-autocomplete>
    <el-autocomplete v-if="searchBy === 'order_id'"
                     placeholder="Order id"
                     v-model="orderId"
                     :fetch-suggestions="searchByOrderId"
                     :debounce="500"
                     :trigger-on-focus="false"
                     value-key="id"
                     @select="getOrders">
      <i class="el-input__icon" :class="[loading ? 'el-icon-loading' : 'el-icon-search']"
         slot="suffix">
      </i>
    </el-autocomplete>
  </div>
</template>

<script>
  /* ============
   * Search Orders Component
   * ============
   *
   * Search orders by email or by order id
   *
   * @emit onOrderFound
   */
  import _ from 'lodash'

  export default {
    name: 'search-orders',
    props: {
      searchBy: {
        type: String,
        default: 'email',
        validator: value => {
          return value === 'email' || value === 'order_id'
        }
      }
    },
    data () {
      return {
        endpoint: `https://api-${process.env.CLO_PHP_API_ENV}.lod.tuango.ca/api/outbox_orders`,
        orders: [],
        email: '',
        orderId: '',
        timeout: null,
        loading: false
      }
    },
    methods: {
      searchByEmail (q, cb) {
        const email = encodeURIComponent(this.email)

        this.$http.get(`${this.endpoint}?email=${email}`)
          .then(res => {
            this.orders = res.data
            cb(_.uniqBy(this.orders, 'email'))
          })
          .catch(err => {
            console.log(err)
          })
      },
      searchByOrderId (q, cb) {
        this.$http.get(`${this.endpoint}?id=${this.orderId}`)
          .then(res => {
            this.orders = res.data
            cb(this.orders)
          })
          .catch(err => {
            console.log(err)
          })
      },
      getOrders () {
        this.loading = true
        let orders

        if (this.searchBy === 'order_id') {
          orders = this.orders.filter(order => order['id'] === this.orderId)
        } else {
          orders = this.orders.filter(order => order['email'] === this.email)
        }

        this.$emit('onOrderFound', orders)
        this.loading = false
      }
    },
    created () {
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/components/outbox/Search.vue